export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "name";
    shortType: string = 'asc';
}

export class functionpermission {
    casemanagercreate: boolean = true
    casemanagerupdate: boolean = true
    casemanagerdelete: boolean = true
}

export class WhereCondition {
    field: string = "name";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class GetCaseListBo {
    SearchColumn: string = "name";
    SearchText: string = "";
    orderColumn: string = "name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    userId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}

export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class caseManagerList {
    id: string;
    name: string;
    state: string;
    street: string;
    zip: string;
    city: string;
    phone: string;
    fax: string;
    agencyId: string;
    email: string;
}


